<h1 mat-dialog-title>Associate company role</h1>

<div mat-dialog-content class="dialog-content">
  <div class="user-summary">
    <div class="user-name">{{data.user.firstName}} {{data.user.lastName}}</div>
    <div class="user-email">{{data.user.email || data.user.phoneNumber || data.user.id}}</div>
  </div>

  <form [formGroup]="form" class="form">
    <mat-form-field appearance="outline">
      <mat-label>Company</mat-label>
      <mat-select formControlName="companyId" panelClass="member-addedit-select-search-panel">
        <mat-option [disabled]="true">
          <ngx-mat-select-search
            [formControl]="companySearchControl"
            noEntriesFoundLabel="No companies"
            placeholderLabel="Search companies..."
          ></ngx-mat-select-search>
        </mat-option>
        @for (company of filteredCompanies; track trackByCompanyId($index, company)) {
          <mat-option [value]="company.id">
            {{company.name}}@if (company.domainName) {
            <span class="option-secondary"> {{company.domainName}}</span>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Role</mat-label>
    <mat-select formControlName="role">
      @for (role of roleOptions; track role) {
        <mat-option [value]="role.value">
          {{role.label}}<span class="option-secondary"> {{role.description}}</span>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (selectedAssociationExists && !successMessage) {
    <div class="message error">
      This user already has that role for the selected company.
    </div>
  }
  @if (errorMessage) {
    <div class="message error">{{errorMessage}}</div>
  }
  @if (successMessage) {
    <div class="message success">{{successMessage}}</div>
  }
</form>

<div class="associations">
  <div class="section-title">Current company roles</div>
  @if (associations.length > 0) {
    <table class="associations-table">
      <thead>
        <tr>
          <th>Company</th>
          <th>Role</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (association of associations; track trackByAssociationId($index, association)) {
          <tr>
            <td>
              {{association.companyName}}
              @if (association.domainName) {
                <span class="option-secondary">{{association.domainName}}</span>
              }
            </td>
            <td>{{association.role}}</td>
            <td class="actions-cell">
              <button
                mat-icon-button
                color="warn"
                [disabled]="saving || !!removingAssociationId"
                (click)="removeAssociation(association)"
                matTooltip="Remove role"
                >
                <mat-icon>{{removingAssociationId === association.id ? 'hourglass_empty' : 'delete'}}</mat-icon>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
  @if (!loading && associations.length === 0) {
    <div class="empty">No company roles associated yet.</div>
  }
  @if (loading) {
    <div class="empty">Loading...</div>
  }
</div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Done</button>
  <button mat-raised-button color="primary" [disabled]="!canSave" (click)="save()">
    {{saving ? 'Saving...' : 'Associate role'}}
  </button>
</div>
